import { makeStyles } from '@material-ui/core';

// Official Kärcher lockup, 153x40 (3.83:1): wordmark over a full-width brand
// bar. The sidebar it sits on is near-black, so the wordmark renders in the
// negative variant; the bar keeps #FFED00 in both themes.
const useStyles = makeStyles(theme => ({
  svg: {
    width: 'auto',
    height: 30,
  },
  bar: {
    fill: '#FFED00',
  },
  wordmark: {
    fill: theme.palette.navigation.selectedColor,
  },
}));

const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 153 40"
      aria-hidden="true"
      focusable="false"
    >
      <path
        className={classes.bar}
        d="M152.172 27.6699H0.183006V40H152.172V27.6699Z"
      />
      <path
        className={classes.wordmark}
        d="M59.5128 7.51649C59.5128 9.48176 58.7406 9.9825 56.8372 9.9825H54.1294V5.24431H56.864C58.8532 5.24431 59.5128 5.77198 59.5128 7.51649ZM66.2795 7.26343C66.2795 2.63293 63.0516 0.387672 56.9766 0.387672H47.6736V21.1819H54.1347V14.333H56.8157L60.3224 21.1819H67.9417L62.6388 13.0892C64.9605 12.2601 66.2849 9.95558 66.2849 7.26881L66.2795 7.26343Z"
      />
      <path
        className={classes.wordmark}
        d="M118.328 16.0506V12.89H126.746V8.34567H118.328V5.57276H128.515L128.403 0.387672H111.867V21.1819H128.816L128.928 16.0506H118.328Z"
      />
      <path
        className={classes.wordmark}
        d="M107.974 21.1819V0.387672H101.54V8.06569H94.6656V0.387672H88.2045V21.1819H94.6656V13.3638H101.54V21.1819H107.974Z"
      />
      <path
        className={classes.wordmark}
        d="M85.2018 0.861489C83.7112 0.360748 81.5878 0 79.6254 0C71.6736 0 68.1401 4.12976 68.1401 10.704C68.1401 17.8005 71.8935 21.5749 79.0731 21.5749C81.2018 21.5749 83.5181 21.0742 85.2607 20.2988L84.5691 15.5283C83.2447 16.056 81.6414 16.3898 79.931 16.3898C75.9846 16.3898 74.9605 15.033 74.9605 10.7363C74.9605 6.66039 75.8988 5.30354 79.872 5.30354C81.7219 5.30354 83.2661 5.57814 84.5637 5.93889L85.1964 0.866873L85.2018 0.861489Z"
      />
      <path
        className={classes.wordmark}
        d="M143.754 7.51649C143.754 9.48176 142.982 9.9825 141.078 9.9825H138.371V5.24431H141.105C143.095 5.24431 143.754 5.77198 143.754 7.51649ZM150.521 7.26343C150.521 2.63293 147.293 0.387672 141.218 0.387672H131.915V21.1819H138.376V14.333H141.057L144.564 21.1819H152.183L146.885 13.0892C149.202 12.2601 150.532 9.95558 150.532 7.26881L150.521 7.26343Z"
      />
      <path
        className={classes.wordmark}
        d="M35.8077 12.8631H31.057L32.7943 7.43034L33.4323 5.26585H33.5128L34.1187 7.43034L35.8023 12.8631H35.8077ZM45.6361 21.1819L37.2447 0.387672H29.7648L21.5289 21.1819H28.4136L29.5181 17.6874H37.3036L38.3814 21.1819H45.6414H45.6361Z"
      />
      <path
        className={classes.wordmark}
        d="M26.9176 0.382278H22.1079V4.79202H26.9176V0.382278Z"
      />
      <path
        className={classes.wordmark}
        d="M44.939 0.382278H40.1294V4.79202H44.939V0.382278Z"
      />
      <path
        className={classes.wordmark}
        d="M13.7112 0.387672L8.71384 8.17876H6.64413V0.387672H0.183006V21.1819H6.64413V13.0569H8.63341L13.6575 21.1819H21.5235L14.376 10.2302L21.1374 0.387672H13.7112Z"
      />
    </svg>
  );
};

export default LogoFull;
